module.exports = __webpack_public_path__ + "img/KO.54f72ea8.webp";